import { useInfiniteQuery } from '@tanstack/react-query';
import { fetchPositions, type PositionsParams } from './positionApi';

/** GET /v1/positions — справочник должностей с поиском. */
export function usePositions(params: PositionsParams = {}) {
  const baseParams = { ...params };
  delete baseParams.page_token;
  return useInfiniteQuery({
    queryKey: ['positions', baseParams],
    queryFn: ({ pageParam }) => fetchPositions({ ...baseParams, page_token: pageParam || undefined }),
    initialPageParam: '',
    getNextPageParam: (lastPage) => lastPage.next_page_token ?? undefined,
    staleTime: 60_000,
  });
}
